module.exports = __webpack_public_path__ + "static/dmon-016-da9a9af91d4a10a23001c2e9d3a85480.jpg";